import { ContentModule } from '@silvertours/common-landingpages-view';

import { Features } from '@silvertours/common-landingpages-i18n';
import { Ui } from '@silvertours/front-shared';
import { ContentModuleSegment } from './ContentArticle.styles';
import { renderContentModule } from './contentModule';

type ContentArticleProps = {
  translations: Features['article'];
  searchQuery?: string;
} & Omit<ContentModule, 'moduleType'>;

const Background = ({ children }: React.PropsWithChildren<object>) => (
  <Ui.PlaneBackground>{children}</Ui.PlaneBackground>
);

export const ContentArticle = ({
  modules,
  translations,
  searchQuery,
}: ContentArticleProps) => {
  if (!modules || modules.length === 0) {
    return null;
  }

  return (
    <>
      {modules.map((module, index) => {
        const Wrapper =
          module.moduleType === 'customerReviews'
            ? Background
            : ContentModuleSegment;
        const key = `${module.moduleType}-${index}`;
        return (
          <Wrapper key={key}>
            {renderContentModule(module, translations, searchQuery)}
          </Wrapper>
        );
      })}
    </>
  );
};
